import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { NavLink, useParams } from 'react-router-dom';

import { Loader, Placeholder } from 'rsuite';

import { retrieve, update } from './actions/Medicines'

export default function Medicines() {
  const { server_id, admin_id } = useParams();
  const [MedicinesData, setMedicinesData] = useState([]);
  const [loading, setLoading] = useState(true);


  const dispatch = useDispatch();
  useEffect(() => {
    fetchMedicines(server_id, admin_id);
  }, [server_id, admin_id]);


  let fetchMedicines = (server_id, admin_id) => {
    setLoading(true);
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      limit: 1,
      last_id: '',
      first_id: '',
    };
    dispatch(retrieve(data)).then((response) => {
      setLoading(false);
      // console.log(response)
      setMedicinesData(response?.response);
    });
  }

  let handleAccess = (device_id, access) => {
    let data = {
      server_id: server_id ? server_id : '',
      admin_id: admin_id ? admin_id : '',
      device_id: device_id,
      access: access,
    }
    dispatch(update(data)).then((response) => {
      setLoading(false);
      fetchMedicines(server_id, admin_id);
    });
  }


  let formatDateTime = (date) => {
    return date;
    console.log(date)
    // if(date && date.length > 0 && time && time.length > 0 && format == 'd/m/y H:i a') {
    //   // console.log(date, time)
    //   let tempDay = date.split('/')[0]
    //   let tempMonth = date.split('/')[1]
    //   let tempYear = date.split('/')[2]
    //   let time_ = time.split(' ')[0];
    //   let hour = time_.split(':')[0];
    //   hour = parseInt(time_.split(':')[0]);
    //   let minute = time_.split(':')[1];
    //   if(time.split(' ')[1] == 'PM') {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? hour < 10 ? hour + 12 : hour + 12 : hour) + ':' + minute + ':00').toISOString();
    //   } else {
    //     return new Date(tempYear + '-' + tempMonth + '-' + tempDay + ' ' + (hour < 12 ? '0' + hour : hour) + ':' + minute + ':00').toISOString();
    //   }
    // } else {
    //   return new Date().toISOString();
    // }
  }
  return (
    <>
      {loading ?
        <div>
          <Placeholder.Paragraph rows={8} />
          <Loader center content="loading" />
        </div>
        :
        <>
          <div className='row'>
            <h4 className='fg-theme mb-2 mt-2'>Medicines</h4>
            {
              MedicinesData && MedicinesData?.length > 0 ?
                MedicinesData.map((val, index) => {
                  return (
                    <div className='col-md-4 mt-1'>
                      <div className='card'>
                        <div className='card-body'>
                          <div className='row'>
                            <div className='container-fluid'>
                              <div className='row'>
                                <div className='col-md-6 text-left'>
                                  <h4 className='fg-theme mb-2 mt-2'>{val?.brand_name ? val?.brand_name : ''}</h4>
                                </div>
                                <div className='col-md-6 text-right'>
                                  <NavLink to={`/Architecture/Servers/${server_id}/Admin/${admin_id}/Medicines/${val.id}/${val.brand_name}/Details`}><button type='button' className='btn btn-primary'><i className='fa fa-angle-right'></i></button></NavLink>
                                </div>
                              </div>
                            </div>
                            <div className='container-fluid'>
                              {/* <h4 className='fg-theme mb-2 mt-2'>{val?.brand_name ? val?.brand_name : ''}</h4> */}
                              {/* <h4 className='f  g-theme mb-2 mt-2'>{val?.admin_user ? val?.admin_user : ''}</h4> */}
                              <p>Company Name : {val?.medicine_company_name}</p>
                              <p>Route of administration : {val?.route_of_administration}</p>
                              <p>Type of Medication : {val?.type_of_medication}</p>
                              <p>Medicines Common Name : {val?.known_as}</p>
                              <p>Created At : {Date(val?.created_at)}</p>
                              {/* <p>Create Date : {formatDateTime(val?.added_on)}</p> */}
                              <p>Status : <i className={`fa fa-${val?.status ? 'toggle-on fg-green' : 'toggle-off fg-red'}`}></i></p>
                              <p>NHS Medicines : <i className={`fa fa-${val?.is_nhs ? 'toggle-on fg-green' : 'toggle-off fg-red'}`}></i></p>
                              <p>Approved : <i className={`fa fa-${val?.is_approved ? 'toggle-on fg-green' : 'toggle-off fg-red'}`}></i></p>
                              <p>Deleted : <i className={`fa fa-${val?.is_trash ? 'toggle-on fg-green' : 'toggle-off fg-red'}`}></i></p>
                              {/* <p>Status : <span className='text-uppercase'>{val?.status}</span></p> */}
                              {/* <p>Access : {val.access?'TRUE':'FALSE'}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
                : ''
            }
          </div>
        </>
      }
    </>
  )
}